export default {
  currentUserInfo: {},
  isJumped: false,
};
